<template>
    <div class="getReport">
        <div class="step">
            <div class="groupS">
                <el-row :gutter="20">
                    <el-col :span="9">
                        <div class="groupList">
                            <label> <span>客戶姓名：</span>
                                <div class="groupCell"><input type="text" v-model="userName" placeholder="請填寫"></div>
                            </label>
                            <p class="ErrorTip" v-show="userNameError">請輸入正確姓名</p>
                        </div>
                    </el-col>
                    <el-col  :span="9">
                        <div class="groupList">
                            <label> <span>手機號碼：</span>
                                <div class="groupCell"><input type="text" maxlength="11"  v-model="phone" placeholder="請填寫"onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></div>
                            </label>
                            <p class="ErrorTip" v-show="phoneError">手機號碼输入错误</p>
                        </div>
                    </el-col>
                    <el-col  :span="4">
                        <button class="nextBtn" @click="getReportBtn">獲取客戶報告</button>
                    </el-col>
<!--                    <el-col  :span="10">-->
<!--                        <div class="groupList">-->
<!--                            <label> <span>驗證碼：</span>-->
<!--                                <div class="groupCell">-->
<!--                                    <input style="width: 1rem;" type="text" v-model="yzCode" placeholder="請填寫">-->
<!--                                    <span @click="sendCode">發送驗證碼</span></div>-->
<!--                            </label>-->
<!--                            <p class="ErrorTip" v-show="yzCodeError">验证码输入错误</p>-->
<!--                        </div>-->
<!--                    </el-col>-->
                </el-row>

                <div style="clear: both;"></div>
            </div>
        </div>
        <div class="step">
            <p class="stepTit">客戶評估報告</p>
            <el-table
                    :data="tableData"
                    border
                    style="width: 100%">
                <el-table-column
                        prop="created_at"
                        label="評估時間"
                        :width="timeW"
                >
                </el-table-column>
                <el-table-column
                        prop="username"
                        label="姓名"
                        :width="nameW"
                >
                </el-table-column>
                <el-table-column
                        prop="sex"
                        label="性別"
                        :width="sexW"
                >
                </el-table-column>
                <el-table-column
                        prop="phone"
                        label="手機號碼"
                        :width="telW">
                </el-table-column>
                <el-table-column
                        prop="package"
                        label="開通套餐"
                        :width="packageW">
                    <template slot-scope="scope">
                        {{scope.row.package}}<span style="color: #76838F;">{{scope.row.is_finish == "2" ? "" : scope.row.is_finish == "1" ? '（已預約生化體檢）' : '（已過期）' }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="id"
                        label="报告下载">
                    <template slot-scope="scope">
                        <el-button
                                size="medium"
                                :type="scope.row.is_finish == '2' ? 'primary' : 'info'"
                                :disabled="scope.is_finish == '2'"
                                @click="handleClick(scope.$index, scope.row)">下載報告</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pag">

                <el-pagination
                        hide-on-single-page
                        @current-change="onCurrentChange"
                        layout="prev, pager, next"
                        :page-size="10"
                        :total="pageCount"
                >
                </el-pagination>
            </div>
        </div>
        <Alert :hidden="alertShow" :tip-status="tipStatus" :tip-text="tipText" @on-close="closeDialog" @on-confirm="confirmDialog"/>
    </div>
</template>

<script>
    import getReport from '../assets/js/getReport'
    import Alert from '../components/alert'
    export default {
        components:{
            Alert
        },
        name: "getReport",
        ...getReport
    }
</script>
<style scoped>
    .getReport >>> .el-pager li.active{
        color: white;
        border-radius: 0.02rem;
        background: #6681FA !important;
    }
    .getReport >>> .el-button--medium{
        padding: 6px 12px;
    }
    .getReport >>> .el-pagination {
        text-align: center;
    }
    .getReport >>> .el-button--primary{
        background: #6681FA;
    }
    .getReport >>> .el-button--info{
        background: #B8BFCC;
    }
</style>

<style src="../assets/css/getReport.css" scoped>

</style>
